export const QA_MODE_COOKIE_NAME = 'ld_qa_lbl';
export const ACCOUNT_COOKIE_NAME = 'hc_accounts';
export const SHIPTO_ID_COOKIE_NAME = 'ssoTSShipToId';
export const LD_ROLLOUT_COOKIE_NAME = 'ld_rollout_group_id';
export const SSO_USER_ROLE_COOKIE_NAME = 'ssoUserRole';
export const SSO_ORIGIN_CUSTOMER_ID_COOKIE_NAME = 'ssoOriginCustomerId';
export const SSO_TS_CUSTOMER_ID_COOKIE_NAME = 'ssoTSCustomerId';
export const SSO_TS_CONTACT_ID_COOKIE_NAME = 'ssoTSContactId';
export const CART_COOKIE_NAME = 'cartId';
export const PUNCHOUT_SESSION_COOKIE_NAME = 'isPunchoutSession';

export const AUTHORIZATION_HEADER_NAME = 'AUTHORIZATION';
export const HC_COUNTRY_HEADER_NAME = 'hc-country';

export const GQL_DATASOURCE_VERSION_HEADER = 'x-graphql-datasource-version';
export const CCMSV1 = 'ccmsv1';
export const CCMSV2 = 'ccmsv2';
export const COS = 'cos';
export const MPIS = 'mpis';
export const SEARCH_SERVICE = 'searchservice';
export const HFLST = 'hflst';
export const LOGOUT_URL = '/logout/dologout';
